import axios from 'axios';
import constants from '../../config/constants'

const api = axios.create({
    baseURL: constants.API_BASE_URL,
    timeout: 10000
})

api.interceptors.response.use(response => {
    return response;
}, error => {
    return Promise.reject(error.response);
});

const token = localStorage.getItem('token');

if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
} else {
    delete api.defaults.headers.common['Authorization'];
}

api.defaults.headers.post['Content-Type'] = 'application/json';
api.defaults.headers.post['Accept'] = 'application/json';

export default api;
